export default "__VITE_ASSET__DZsy07Lt__"